(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-landing-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  const buyButtons = document.querySelectorAll('.of-embedded .of-bundle-buy');
  if (!buyButtons.length) return;
  buyButtons.forEach(function(btn) {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;
      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Preparing…';
      buyButtons.forEach(function(b) { if (b !== btn) b.disabled = true; });
      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add-failed');
        window.location.href = '/checkout';
      } catch (err) {
        btn.disabled = false;
        btn.innerHTML = originalText;
        buyButtons.forEach(function(b) { b.disabled = false; });
        alert('Something went wrong. Please try again, or email amanda@helloherbly.com.');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-form"] && !Shopify.designMode) return;
  try {
    
(function() {
  const wrapInput = document.querySelector('.of-page input[name="wrap"]');
  const wrapContainer = document.querySelector('.of-page .of-wrap');

  if (wrapContainer && wrapInput) {
    wrapContainer.addEventListener('click', function(e) {
      // Native label click toggles input; then update visual state
      setTimeout(function() {
        wrapContainer.classList.toggle('selected', wrapInput.checked);
      }, 0);
    });
    wrapInput.addEventListener('change', function() {
      wrapContainer.classList.toggle('selected', wrapInput.checked);
    });
  }

  const buyButtons = document.querySelectorAll('.of-page .of-bundle-buy');
  buyButtons.forEach(function(btn) {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      const items = [{ id: variantId, quantity: 1 }];
      if (wrapInput && wrapInput.checked) {
        items.push({ id: parseInt(wrapInput.value, 10), quantity: 1 });
      }

      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Preparing…';

      // Also disable siblings during redirect
      buyButtons.forEach(function(b) { if (b !== btn) b.disabled = true; });

      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) throw new Error('add-failed');
        window.location.href = '/checkout';
      } catch (err) {
        btn.disabled = false;
        btn.innerHTML = originalText;
        buyButtons.forEach(function(b) { b.disabled = false; });
        alert('Something went wrong. Please try again, or email amanda@helloherbly.com.');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
